import { Skeleton } from "@/components/ui/skeleton";

const ProductDetailSkeleton = () => {
  return (
    <div className="grid lg:grid-cols-3 gap-12">
      {/* Image */}
      <div className="bg-white border border-border/50 rounded-lg p-4">
        <Skeleton className="aspect-square rounded-lg" />
      </div>

      {/* Info */}
      <div className="space-y-6 lg:col-span-2">
        <div className="space-y-3">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-10 w-3/4" />
          <Skeleton className="h-8 w-32" />
        </div>

        {/* Description */}
        <div className="space-y-2">
          <Skeleton className="h-5 w-full" />
          <Skeleton className="h-5 w-full" />
          <Skeleton className="h-5 w-2/3" />
        </div>

        {/* Variations */}
        <div className="space-y-3">
          <Skeleton className="h-4 w-40" />
          <div className="flex gap-3">
            <Skeleton className="h-10 w-20 rounded-md" />
            <Skeleton className="h-10 w-20 rounded-md" />
            <Skeleton className="h-10 w-24 rounded-md" />
          </div>
        </div>

        {/* Buttons */}
        <div className="pt-6 space-y-4">
          <div className="flex flex-col sm:flex-row gap-3">
            <Skeleton className="h-12 w-full sm:w-48" />
            <Skeleton className="h-12 w-full sm:w-56" />
          </div>
          <Skeleton className="h-4 w-64" />
        </div>

        {/* Additional Info */}
        <div className="pt-6 border-t border-border space-y-4">
          <div className="flex items-center gap-3">
            <Skeleton className="w-2 h-2 rounded-full" />
            <Skeleton className="h-4 w-40" />
          </div>
          <div className="flex items-center gap-3">
            <Skeleton className="w-2 h-2 rounded-full" />
            <Skeleton className="h-4 w-52" />
          </div>
          <div className="flex items-center gap-3">
            <Skeleton className="w-2 h-2 rounded-full" />
            <Skeleton className="h-4 w-44" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailSkeleton;
